import { useEffect, useState } from 'react';
import { LoadingSpinner } from '../../ui/loader/components/LoadingSpinner';

const DEFAULT_DELAY_MS = 500;

export interface DelayedLoadingSpinnerProps {
  delay?: number;
}

export const DelayedLoadingSpinner = ({
  delay = DEFAULT_DELAY_MS,
}: DelayedLoadingSpinnerProps) => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowLoading(true);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [delay]);

  if (!showLoading) {
    return null;
  }

  return <LoadingSpinner />;
};
